export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-gamer-3bb20f90896259c98c15d51c7a7fe6ee.png";